import fetch from 'utils/fetch';

export function syncProduct(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/syncProduct',
        method: 'post',
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/syncProduct.js